import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	/**
	 * @queryParams {*} queryParams
	 */
	findAll (queryParams = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/event/payments', {
				params: queryParams
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/event/payment.js